import { Colors, Fonts } from '../../../../shared/theme';

export default {
  formWrapper: {
    backgroundColor: Colors.white,
    padding: 40
  } as React.CSSProperties,
  headerRemark: {
    marginBottom : '20px'
  } as React.CSSProperties,
  textRegular14DarkGray: {
    fontFamily: Fonts.type.KanitRegular,
    fontSize: Fonts.size.text14,
    color: Colors.font.primary.darkGray
  } as React.CSSProperties,
};
